import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LoginUser } from '../models/login-user';
import { ApiResponse } from '../models/api-response';
import { UserMenuNodes } from '../models/user-menu-nodes';
import { ComponentsType } from '../models/component-data';

import { AppConfigService } from '../app-config.service.service';
import { ToastService } from 'ng-uikit-pro-standard';


@Injectable({
  providedIn: 'root'
})
export class DasboardService {
  private uri = "";// `${environment.apiUrl}`;
  private moduleId;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private toastService: ToastService) {
    this.uri = this.appConfigService.apiBaseUrl;

   }

  getDashboard() {
    this.uri = this.appConfigService.apiBaseUrl;
    this.moduleId = sessionStorage.getItem('moduleId');
    return this.http.post<any>(this.uri + '/Dashboard', {
      moduleid: this.moduleId
    });
  }

  getDashboardById(id) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<ComponentsType[]>(this.uri + '/DashboardComponents', {DashboardID: id});
  }

  getDashboardByIdCubeBox(params) {
    console.log(params)
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<ComponentsType[]>(this.uri + '/DashboardComponents', params );
  }

  getUsers() {
    this.uri = this.appConfigService.apiBaseUrl;

    return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'Get_AllUser' });

  }

  shareDashboard(obj: any) {
    this.uri = this.appConfigService.apiBaseUrl;

    return this.http.post<any>(this.uri + '/FlexIntegration', obj );

  }

  getData(componentId) {
    // return this.http.post<any>(this.uri + endpoint, {});
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post(this.uri + '/DashboardsComponentsData/GetData', {ComponentID: componentId});
  }

  deleteDashboard(id) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/Dashboard/Delete_Dashboard', {id: id});
  }

  updateDashboard(item) {
    this.uri = this.appConfigService.apiBaseUrl;
    this.moduleId = sessionStorage.getItem('moduleId');
    item.moduleid = this.moduleId;
    return this.http.post<any>(this.uri + '/Dashboard/Update_Dashboard', item);
  }

  newDashboard(newDashboard) {
    this.uri = this.appConfigService.apiBaseUrl;
    this.moduleId = sessionStorage.getItem('moduleId');
    newDashboard.moduleid = this.moduleId;
    // console.log(newDashboard);
    // return;
    return this.http.post<any>(this.uri + '/Dashboard/InsertDashboard', newDashboard);
  }

  GetALlDashboardComponents() {
    this.uri = this.appConfigService.apiBaseUrl;
    this.moduleId = sessionStorage.getItem('moduleId');
    if (!this.moduleId) {
      this.toastService.info('The module is not defined');
    }
    return this.http.post<any>(this.uri + '/DashboardComponents/GetALlDashboardComponents', {
      moduleid: this.moduleId
    });
  }

  addNewComponentDashboard(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/InsertDashboardComponents', model);
  }

  UpdateDashBoardComponents(dashboardid, list) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post(this.uri + '/DashboardComponents/UpdateDashBoardComponents', {DashboardID: dashboardid, Components: list});
  }

  UpdateDashBoardComponentsGridster(dashboardid, list) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'UpdateDashBoardComponentsGridster', dashboardid: dashboardid, listjson: list });
  }

  GetDashBoardComponentsGridster(dashboardid) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'GetDashBoardComponentsGridster', dashboardid: dashboardid });
  }

  // admin component
  GetDashboardComponentsConf(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsConf', model);
  }

  GetDashboardComponentsConfDataSources() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsConfDataSources', {});
  }

  GetMasterDashboardComponentsConfDataSources() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'Get_MasterDashboardComponentsDataSources'});
  }

  SaveDashboardModules(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  UpdateComponentsConfDataSources(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/UpdateComponentsConfDataSources', model);
    // tslint:disable-next-line: max-line-length
    // {ComponentId: 0, Name: 'ComponentName', Description: 'ComponentDescription', ComponentTypeId: 9, DataSource: 'ComponentDataSourceTEXT'}
  }

  Get_ClientDashboards(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  UpdateMasterComponents(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = 'InsertUpdate_DashboardComponents';
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  DeleteComponent(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  DeleteComponentsConfDataSources(id) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/DeleteComponentsConfDataSources', {ComponentId: id});
  }

  GetDashboardComponentsModules() {
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsModules', {});
  }

  GetDashboardComponentsUserGroup() {
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsUserGroup', {});
  }

  GetDashboardComponentsConfModulesUserGroups(componentid) {
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsConfModulesUserGroups', {ComponentId: componentid});
  }
}
